<ng-container>
  <span [attr.aria-label]="'Timeslot ' + timeslot">
    {{ timeslot }}
  </span>
</ng-container>
